// evo/rooms/evoRoomBadges.ts
// MPH-648: the room-card header shows at most MAX_EVO_ROOM_BADGES badges, picked by priority:
// my price → pink people → LMN deal / flash sale → kids stay free → periodic promotions (Black
// Friday, Summer Sale, …) → "only X rooms left". Lower-priority badges are dropped first; display
// order follows priority.
//
// MPH-935: my price and pink people lead, as they do on the Evo results card. They are the two that
// say the rate itself is different — quoted for this member, or a members-only price — rather than
// advertising an offer laid on top of a rate everyone can book. In practice a rate carries one or the
// other, so between them they normally take a single slot; nothing enforces that, though (isMyPrice
// comes off the rate's default price key and isEmployeeDiscount off its discount list, and legacy
// renders both together), so a rate carrying both simply spends both slots and drops the deal badge.

export const MAX_EVO_ROOM_BADGES = 2;

export const EVO_ROOM_BADGE_PRIORITY = [
  'MY_PRICE',
  'PINK_PEOPLE',
  'LMN_DEAL',
  'KIDS_STAY_FREE',
  'PERIODIC_PROMOTION',
  'ROOMS_LEFT',
] as const;

export type EvoRoomBadge = (typeof EVO_ROOM_BADGE_PRIORITY)[number];

export function getVisibleEvoRoomBadges(eligible: Record<EvoRoomBadge, boolean>): EvoRoomBadge[] {
  return EVO_ROOM_BADGE_PRIORITY.filter((badge) => eligible[badge]).slice(0, MAX_EVO_ROOM_BADGES);
}
